import { IFillDataWizardBuy } from "../../../pages/buy/components/wizard";
import Estimate, {
  IDataFormEstimate,
  TModeEstimate,
} from "../../../pages/estimate";
import BaseStep from "./baseStep";
import { ICounterPage } from "./types";

interface IEstimateStep {
  onEstimateForm: (data: Partial<IFillDataWizardBuy>) => void;
  onEstimatePrice: (data: number) => void;
  onPrevStep?: () => void;
  onNexStep: () => void;
  isNextStepDisabled: boolean;
  mode: TModeEstimate;
  dataFormEstimate: IDataFormEstimate | undefined;
  numPage?: number;
  counterPage?: ICounterPage;
}

const EstimateStep = ({
  onPrevStep,
  onNexStep,
  onEstimateForm,
  onEstimatePrice,
  isNextStepDisabled,
  mode,
  dataFormEstimate,
  counterPage,
}: IEstimateStep) => {

  return (
    <BaseStep
      counterPage={counterPage}
      prevStep={onPrevStep}
      nextStep={onNexStep}
      isNextStepDisabled={isNextStepDisabled}
    >
      <Estimate
        mode={mode}
        onDataFormEstimate={onEstimateForm}
        onDataEstimatePrice={onEstimatePrice}
        dataForm={dataFormEstimate}
      />
    </BaseStep>
  );
};

export default EstimateStep;
